import React from 'react';
import styled from 'styled-components';
import { ReactComponent as DoneIcon } from 'assets/done_icon.svg';
import { branch, renderNothing } from 'recompose';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled(DoneIcon)`
  width: 30px;
  height: 30px;
  margin-right: 10px;
`;

const SuccessfullyChanged = ({ message }: IProps) => {
  return (
    <Wrapper>
      <Icon />
      {message}
    </Wrapper>
  );
};

export default branch(
  ({ isOpen }: IProps) => !isOpen && typeof isOpen !== 'undefined',
  renderNothing,
)(SuccessfullyChanged);

interface IProps {
  message: string;
  isOpen?: boolean;
}
